import { Message } from '~widgets/Contacts/ui/ContactsItem/styles';

import { Dot, DotContainer, Wrapper } from './TypingIndicator.styles';

export const TypingIndicator = () => (
	<Wrapper>
		<DotContainer>
			<Dot />
			<Dot />
			<Dot />
		</DotContainer>
		<Message size="M" align="left">
			typing
		</Message>
	</Wrapper>
);
